module.exports = __webpack_public_path__ + "static/media/Parco dell acqua - Peri_DK Gold.f77e3a56.jpg";